import style from "../calculator.module.css";
function TooltipError() {
  return (<div className={style.calculator_invalid_tooltip}>O valor deve ser maior que 0.</div>);
}
export {
  TooltipError
};